import { html } from "lit-element";

export const line_linearScale = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"></path>
</svg>
`;

export const line_callMade = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"></path>
</svg>
`;

export const line_arrow2 = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M 9 5 v 2 h 6.6 L 4 18.6 L 5.4 20 L 17 8.4 V 15 h 2 V 5 z" />
    <path transform="rotate(180,12,12), translate(1,-1)" d="M 9 5 v 2 h 6.6 L 4 18.6 L 5.4 20 L 17 8.4 V 15 h 2 V 5 z" />
</svg>
`;

export const line_dotted = html`		  
<svg width="24" height="24" version="1.1" xmlns="http://www.w3.org/2000/svg">
	 <line stroke-dasharray="3, 3" x1="2" y1="13" x2="23" y2="13" style="stroke: rgb(255, 255, 255); stroke-width: 4px;"></line>
</svg>		  	  
`;

export const line_dashed = html`
<svg width="24" height="24" version="1.1" xmlns="http://www.w3.org/2000/svg">
	 <line stroke-dasharray="10, 5" x1="2" y1="13" x2="23" y2="13" style="stroke: rgb(255, 255, 255); stroke-width: 4px;"></line>
</svg>		  
`;
